import { NavLink, Outlet, Navigate, useLocation } from 'react-router-dom';
import { Database, Apple, Scale, Sparkles } from 'lucide-react';

const TABS = [
  { to: '/admin/mass-db/enrichment', label: 'Enrichment', icon: Sparkles },
  { to: '/admin/mass-db/sync', label: 'Data Sync', icon: Database },
  { to: '/admin/mass-db/ciqual', label: 'CIQUAL', icon: Apple },
  { to: '/admin/mass-db/conversion', label: 'Conversion', icon: Scale },
] as const;

export function MassDbPage() {
  const location = useLocation();

  if (location.pathname === '/admin/mass-db' || location.pathname === '/admin/mass-db/') {
    return <Navigate to="/admin/mass-db/enrichment" replace />;
  }

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-display font-bold text-menioo-navy">Mass DB</h2>
        <p className="text-sm text-gray-500 mt-1">
          Enrichissement unifié (CIQUAL + conversion), sync, imports USDA/CIQUAL.
        </p>
      </div>

      <div className="border-b border-gray-200">
        <nav className="flex gap-1 -mb-px overflow-x-auto">
          {TABS.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) => {
                const active =
                  isActive ||
                  (to === '/admin/mass-db/enrichment' &&
                    location.pathname.startsWith('/admin/mass-db/enrichment')) ||
                  (to === '/admin/mass-db/ciqual' &&
                    location.pathname.startsWith('/admin/mass-db/ciqual')) ||
                  (to === '/admin/mass-db/conversion' &&
                    location.pathname.startsWith('/admin/mass-db/conversion'));
                return `inline-flex items-center px-4 py-2.5 text-sm font-medium border-b-2 whitespace-nowrap ${
                  active
                    ? 'border-menioo-green text-menioo-green'
                    : 'border-transparent text-gray-500 hover:text-menioo-navy hover:border-gray-300'
                }`;
              }}
            >
              <Icon className="h-4 w-4 mr-2" />
              {label}
            </NavLink>
          ))}
        </nav>
      </div>

      <Outlet />
    </div>
  );
}
